import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "p-about__ttl--primary c-ttl--primary" }, "お問い合わせ内容 確認", -1)
const _hoisted_2 = { class: "p-about__sec" }
const _hoisted_3 = { class: "p-contact__field-container" }
const _hoisted_4 = {
  key: 0,
  class: "c-error"
}
const _hoisted_5 = { class: "p-fields p-fields--confirm" }
const _hoisted_6 = { class: "c-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "お名前", -1)
const _hoisted_8 = { class: "c-field__body" }
const _hoisted_9 = { class: "c-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "ふりがな", -1)
const _hoisted_11 = { class: "c-field__body" }
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "c-field__label",
  for: ""
}, "メールアドレス", -1)
const _hoisted_15 = { class: "c-field__body" }
const _hoisted_16 = { class: "c-field__body" }
const _hoisted_17 = { class: "c-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "c-field__label",
  for: "subject"
}, "ご利用サービス", -1)
const _hoisted_19 = { class: "c-field__body" }
const _hoisted_20 = { class: "c-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "c-field__label",
  for: "subject"
}, "お問い合わせ項目", -1)
const _hoisted_22 = { class: "c-field__body" }
const _hoisted_23 = { class: "c-field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "c-field__label",
  for: "detail"
}, "お問い合わせ内容", -1)
const _hoisted_25 = {
  class: "c-field__body",
  style: {"flex-direction":"column"}
}
const _hoisted_26 = { class: "c-field has-submit has-mt" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "送信する", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "キャンセル", -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMsgRef)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMsgRef), 1))
          : _createCommentVNode("", true),
        _createElementVNode("fieldset", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(_ctx.contactFormItems.lastName) + " " + _toDisplayString(_ctx.contactFormItems.firstName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", null, _toDisplayString(_ctx.contactFormItems.lastKana) + " " + _toDisplayString(_ctx.contactFormItems.firstKana), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(_ctx.contactFormItems.email), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(_ctx.contactFormItems.service), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", null, _toDisplayString(_ctx.contactFormItems.subject), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactFormItems.detail.split('\n'), (line, idx) => {
                return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(line), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.send, this))),
              class: "c-btn is-submit",
              disabled: _ctx.isDeterringRef
            }, _hoisted_29, 8, _hoisted_27),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "c-btn c-btn--sub",
              disabled: _ctx.isDeterringRef
            }, _hoisted_32, 8, _hoisted_30)
          ])
        ])
      ])
    ])
  ], 64))
}